import React, { Component, } from 'react'
import PropTypes from 'prop-types'

class Four0FourScene extends Component {
  static propTypes = {
    actions: PropTypes.shape({
      navHome: PropTypes.func.isRequired,
    }).isRequired,
  }

  goToHomePage = () => {
    this.props.actions.navHome()
  }
  render() {
    const { goToHomePage, } = this
    return (
      <div>
        <h2> 404 - Page not found </h2>
        <p>
          <a onClick={goToHomePage}>Please click here to go to the homepage.</a>
        </p>
      </div>
    )
  }
}

export default Four0FourScene



// WEBPACK FOOTER //
// ./src/components/_sceneManager/Scenes/Four0FourScene/component.js